import { BufferGeometry, Object3D } from 'three';

import { EdgeProjection, Outline2D } from '../math/index.js';

declare module 'three' {
  export interface BufferGeometry {
    computeEdgeProjection: typeof computeEdgeProjection;
    edgeProjection: EdgeProjection | null;

    computeOutline2D: typeof computeOutline2D;
    outline2D: Outline2D | null;
  }
  export interface Object3D {
    computeEdgeProjection: typeof computeEdgeProjectionObject3D;
    edgeProjection: EdgeProjection | null;

    computeOutline2D: typeof computeOutline2D;
    outline2D: Outline2D | null;
  }
}

BufferGeometry.prototype.computeEdgeProjection = computeEdgeProjection;
BufferGeometry.prototype.edgeProjection = null;

BufferGeometry.prototype.computeOutline2D = computeOutline2D;
BufferGeometry.prototype.outline2D = null;

Object3D.prototype.computeEdgeProjection = computeEdgeProjectionObject3D;
Object3D.prototype.edgeProjection = null;

Object3D.prototype.computeOutline2D = computeOutline2D;
Object3D.prototype.outline2D = null;

function computeEdgeProjection(this: BufferGeometry): void {
  this.edgeProjection = new EdgeProjection().setFromGeometry(this);
}

function computeEdgeProjectionObject3D(this: Object3D): void {
  this.edgeProjection = new EdgeProjection().setFromObject(this);
}

function computeOutline2D(this: BufferGeometry | Object3D): void {
  if (!this.edgeProjection) {
    (this as any).computeEdgeProjection();
  }

  if (!this.edgeProjection?.buffer) {
    throw new Error('Edge projection is unavailable');
  }

  this.outline2D = new Outline2D().setFromGeometry(this.edgeProjection.buffer);
}
